import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { ConsumoListarComponent } from './consumo-listar.component';

const routes: Routes = [];

@NgModule({
  imports: [RouterModule.forChild([
    {path:'', component: ConsumoListarComponent}
  ])],
  exports: [RouterModule]
})
export class ConsumoListarRoutingModule { }
